module.exports = __webpack_public_path__ + "static/img/driblab_color.378897b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_color.jpeg
// module id = 1X2A
// module chunks = 94